interface Feature {
  title: string;
  desc: string;
  soon?: boolean;
}

function Section({
  id,
  kicker,
  title,
  titleAccent,
  features,
}: {
  id: string;
  kicker: string;
  title: string;
  titleAccent: string;
  features: Feature[];
}) {
  return (
    <section id={id} className="max-w-6xl mx-auto px-6 py-20 scroll-mt-20">
      <p className="text-[11px] font-semibold tracking-[0.25em] text-[#8A8578] uppercase">
        {kicker}
      </p>
      <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight max-w-2xl">
        <span className="font-extrabold text-[#141414]">{title} </span>
        <span className="italic font-semibold text-[#8A8578]">{titleAccent}</span>
      </h2>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {features.map((f) => (
          <div
            key={f.title}
            className="bg-white rounded-2xl p-6 shadow-[0_24px_60px_-40px_rgba(20,20,20,0.35)]"
          >
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-bold text-[15px] text-[#141414] leading-snug">{f.title}</h3>
              {f.soon && (
                <span className="shrink-0 text-[10px] font-semibold tracking-wider uppercase bg-[#F5F0E8] text-[#8A8578] rounded-full px-2 py-0.5">
                  Próximamente
                </span>
              )}
            </div>
            <p className="mt-2 text-sm leading-relaxed text-[#141414]/65">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function PropertiesSection() {
  return (
    <Section
      id="propiedades"
      kicker="Promociona y vende"
      title="Todo tu inventario,"
      titleAccent="presentable y compartible."
      features={[
        { title: 'Propiedades con galería', desc: 'Fotos en la nube, portada elegible y ficha completa de cada inmueble.' },
        { title: 'Selecciones para clientes', desc: 'Arma una curaduría y compártela con un link — sin cuentas, sin fricción.' },
        { title: 'Seguimiento de prospectos', desc: 'Cada interesado en su etapa, del primer contacto al cierre. Nada se pierde.' },
        { title: 'Buscador público', desc: 'Tu catálogo con filtros para captar interesados desde tus anuncios.' },
      ]}
    />
  );
}

export function RentalsSection() {
  return (
    <Section
      id="rentas"
      kicker="Administra tus rentas"
      title="Cobra a tiempo,"
      titleAccent="decide con datos, no con intuición."
      features={[
        { title: 'Contratos y unidades', desc: 'Cada depto o local con su contrato, inquilino y términos.' },
        { title: 'Cobros que se generan solos', desc: 'Un periodo por mes de vigencia, con su fecha de corte.' },
        { title: 'Morosos con días de atraso', desc: 'El dashboard te dice quién debe, cuánto y desde cuándo.' },
        { title: 'Incrementos con historial', desc: 'Sube la renta con registro de cuándo, cuánto y por qué.' },
      ]}
    />
  );
}

export function TenantsSection() {
  return (
    <Section
      id="inquilinos"
      kicker="Atiende a tus inquilinos"
      title="Menos llamadas,"
      titleAccent="más claridad."
      features={[
        { title: 'Portal del inquilino', desc: 'Cada cliente ve sus propiedades asignadas y responde con un tap.' },
        { title: 'Historial de pagos', desc: 'Cada pago queda registrado: cuándo, cuánto y de qué mes.' },
        { title: 'Recordatorios por WhatsApp', desc: 'Aviso antes del corte y seguimiento de vencidos, automático.', soon: true },
      ]}
    />
  );
}
